module.exports = __webpack_public_path__ + "static/media/due-port03.0d02d35f.jpg";